import { useState } from "react";
const Experiance = () => {
  const [state] = useState([
    {
      id: 1,
      title: "React Context and Sass Create a Real World Website",
      border: "border-violet-600",
      link: "https://www.udemy.com/course/react-context-create-responsive-website/?referralCode=5A3777F5B0E37FF01FD8",
    },
    {
      id: 2,
      title: "Sass the Complete Guide",
      border: "border-orange-600",
      link: "https://www.udemy.com/course/html-sass-javascript-create-responsive-portfolio-website/?referralCode=049014593C71E2160BD2",
    },
    {
      id: 3,
      title: "Tailwind CSS the Complete Guide, Build Projects",
      border: "border-emerald-600",
      link: "https://www.udemy.com/course/tailwind-css-the-complete-guide-build-projects/?referralCode=AEA14DCDA29745622FF3",
    },
  ]);
  return (
    <div className="py-[90px] dark:bg-gray-900">
      <div className="container-block">
        <div className="flex flex-wrap -mx-5 items-center">
          <div className="w-full md:w-6/12 p-5 pr-10">
            <h1 className="heading mb-8">experiance</h1>
            <h1 className="text-4xl leading-[45px] font-bold dark:text-white">
              Trained <span className="text-teal-700">Thousands</span>, of
              students <span className="text-teal-700">online</span> & Created
              awesome projects for the client worldwide..
            </h1>
            <p className="mt-5 text-base leading-[27px] dark:text-white">
              I have trained thousands of students online through Udemy platform
              and Youtube, and I have created many projects for clients.
            </p>
          </div>
          <div className="w-full md:w-6/12 p-5 ">
            <div className="flex">
              <div className="w-3/12">
                <span className="text-lg font-semibold text-teal-600">
                  2022 - Present
                </span>
              </div>
              <div className="w-9/12 relative">
                <h1 className="text-lg font-bold capitalize relative before:absolute before:top-0 before:-left-1 before:w-[30px] before:h-[20px] z-10 before:-z-10 before:bg-green-500 dark:text-white">
                  backend developer
                </h1>
                <span className="text-gray-500 capitalize text-sm dark:text-gray-300">
                  hidden logics.
                </span>
                <p className="mt-2 font-medium dark:text-gray-200">
                  API's, API's Testing, Heroku, AWS, Node JS
                </p>
              </div>
            </div>
            <div className="flex mt-8">
              <div className="w-3/12">
                <span className="text-lg font-semibold text-teal-600">
                  2017 - Present
                </span>
              </div>
              <div className="w-9/12 relative">
                <h1 className="text-lg font-bold capitalize relative before:absolute before:top-0 before:-left-1 before:w-[30px] before:h-[20px] z-10 before:-z-10 before:bg-violet-600 dark:text-white">
                  udemy instructor
                </h1>
                <span className="text-gray-500 capitalize text-sm dark:text-gray-300">
                  udemy.
                </span>
                <p className="mt-2 text-gray-700 font-medium dark:text-gray-200">
                  {state.map((exp) => (
                    <a href={exp.link} key={exp.id} target="_blank">
                      <span className={`border-b-2 ${exp.border}`}>
                        {exp.title}
                      </span>{" "}
                    </a>
                  ))}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experiance;
